export default __webpack_public_path__ + "static/media/web-2.b271a846.webp";